'use strict';

angular.module('theme').filter('round', function() {
	//We add a filter to this controller and use it for rounding down the price in html
	return function (value, mult, dir) {
		dir = dir || 'nearest';
		mult = mult || 1;
		value = !value ? 0 : Number(value);
		if (dir === 'up') {
			return Math.ceil(value / mult) * mult;
		} else if (dir === 'down') {
			return Math.floor(value / mult) * mult;
		} else {
			return Math.round(value / mult) * mult;
		}
	};
}).component('orderProduct', {
	templateUrl: 'component/order-product.html',
	bindings: {
		productId: '@',
		productTagLine: '@',
		productTitle: '@',
	},
	controller: function ($scope, $window, $location, $cookies, CartService, ArticleService, ProductService, TrackerService, ProductTrackerService) {
		var self = this;

		self.special = self.productId === 'Special';

		if ($cookies.get('campaign-code-discount')) {
			var discount = JSON.parse($cookies.get('campaign-code-discount'));

			self.discountCode = discount.code;

			if (!discount || discount.code === '') return;

			if (discount.type === 'Percent') {
				self.percentDiscount = Math.abs(discount.value) / 100;
			} else if(discount.amount) {
				var value = Math.abs(discount.amount);

				if (value == 0) return;

				self.discount = value;
			}
		}

		ArticleService.getProduct(self.productId).then(function (product) {
			self.product = product;
			self.prices = product.prices;

			self.selected = _.find(self.prices, function(price) {
				if (self.special) return price.number === 1;
				return price.number === 4;
			});

			ProductTrackerService.updateProduct(self.product, self.selected, self.getServings());
			//ProductTrackerService.viewItemProductPage(self.product, self.selected);
		});

		ProductService.list().then(function(response) {
			self.currentProductServings = response.find(function(product) {
				return product.product_id === self.productId;
			}).servings;
		}).catch(function(error) {
			console.error(error);
		});

		this.setSelected = function (price) {
			self.selected = price;

			ProductTrackerService.productChange(self.product.type, price);
		};

		this.trackerCart = function (longname, quantity, dc, price, type) {
			ProductTrackerService.addToCartEvent(longname, quantity, dc, price, type);
		};

		this.select = function () {
			CartService.add(self.product, this.selected.number).then(function () {

				// get wordpress product
				ProductService.get(self.product.type).then(function (product) {
					var data = {
						'currency': 'SEK',
						'add': {
							'actionField': {'list': window.location.pathname},
							'products': [{
								'name': product.title,
								'id': self.product.type,
								'price': self.selected.amount,
								'quantity': 1,
								'dimension3': self.getServings(),
								'dimension4': self.selected.number
							}]
						}
					};

					//TrackerService.ecommerceEvent('addToCart', data);
				});

				TrackerService.addToCart(self.product, self.selected.amount);

				// redirect to cart
				$window.location.href = '/order/';
			});
		};

		this.getServings = function () {
			switch(self.productId) {
			case 'VEGO':
			case 'STHLM':
				return 3;
			default:
				return 4;
			}
		};
	}
});
